var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 2.66675H7.99998C6.53331 2.66675 5.34665 3.86675 5.34665 5.33341L5.33331 26.6667C5.33331 28.1334 6.51998 29.3334 7.98665 29.3334H24C25.4666 29.3334 26.6666 28.1334 26.6666 26.6667V10.6667L18.6666 2.66675ZM24 26.6667H7.99998V5.33341H17.3333V12.0001H24V26.6667ZM10.6666 20.0134L12.5466 21.8934L14.6666 19.7867V25.3334H17.3333V19.7867L19.4533 21.9067L21.3333 20.0134L16.0133 14.6667L10.6666 20.0134Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.9f37c2213f06067dd544705119c0adad.svg";
export { ForwardRef as ReactComponent };